module.exports = __webpack_public_path__ + "img/logo.3fb292da.svg";